import { useTheme } from "@mui/material";
import { ExperienceActionDto } from "@intelligems/ig-types/dtos/experience-actions";
import { ExperienceListDto } from "@intelligems/ig-types/dtos/experiences-list";
import { ScheduleDto } from "@intelligems/ig-types/dtos/schedule";
import { TabEnumFe } from "@intelligems/ig-types/fe-only/experiences";
import { IgChip } from "@intelligems/ig-theme/IgChip";
import { IgTooltip } from "@intelligems/ig-theme/IgTooltip";
import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import { IgTypographyTooltip } from "@intelligems/ig-theme/IgTypographyTooltip";
import { getDaysFromHistory } from "@intelligems/ig-analytics/date";
import { getRuntimeDisplayLabel } from "@src/domains/experienceTablePages/experienceRuntime";

export const RuntimeLabel = ({
  experienceActions,
  hasExpEverStarted,
}: {
  experienceActions: ExperienceActionDto[];
  hasExpEverStarted: boolean;
}) => {
  const theme = useTheme();

  if (!hasExpEverStarted) {
    return <IgTypography color={theme.palette.text.secondary}>-</IgTypography>;
  }

  const runtimeDays = Math.ceil(getDaysFromHistory(experienceActions));
  const label = getRuntimeDisplayLabel(runtimeDays);

  return (
    <IgTypography color={theme.palette.text.secondary} variant={"body1"}>
      {label}
    </IgTypography>
  );
};
